export const appHost = process.env.REACT_APP_HOST || '';

export const hotjarAppId = process.env.REACT_APP_HOTJAR_ID || '';

export const hotjarAppVersion = process.env.REACT_APP_HOTJAR_VERSION || '';

export const isProductionEnv = process.env.NODE_ENV === 'production';

export const isStaging = process.env.REACT_APP_TARGET_ENV === 'staging';

export const mixpanelToken = process.env.REACT_APP_MIXPANEL_TOKEN || '';

export const proxyHost = process.env.REACT_APP_PROXY_HOST || '';

export const sentryDNS = process.env.REACT_APP_SENTRY_DNS;

export const webappHost = process.env.REACT_APP_WEBAPP_HOST || '';

export const webappHostMx = process.env.REACT_APP_WEBAPP_HOST_MX || '';

export const wootricToken = process.env.REACT_APP_WOOTRIC_TOKEN || '';

export const googleTagManagerId = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID || '';

export const termsOfServiceVersion = process.env.REACT_TERMS_OF_SERVICE_VERSION || '';

export const regionApp = process.env.REACT_APP_REGION || undefined;
